@if (visible) {
  <div class="modal_customer">
    <div class="modal_customer_body">
      <div class="modal_customer_close" (click)="dismiss()">
        Close
      </div>
      <br>
        <br>
          <div class="modal_text_md" style="margin-bottom: 10px;">
            PECCBM Program<br>
            Privacy Policy and Terms & Conditions
          </div>
          <div class="modal_text_sm" style="margin-bottom: 10px;">
            <p class="terms_title">Meralco values your privacy.</p>
            We collect your name, email address, mobile number, date of birth, and address to process and notify you
            about your service request. We keep this data only for a period of 4 years after your last activity and
            properly dispose of it subsequently. We share this data with our third-party service providers, your
            selected <strong>private electrical contractors certified by MERALCO (PECCBM)</strong>, who process them independently
            to perform intended services. The certified by Meralco Private Electrical Contractors are not employees,
            agents, subsidiaries, or affiliates of Meralco, and transactions made with them do not involve us. As such,
            their use of your personal data for their own legitimate purposes is outside the scope of Meralco’s
            personal data processing.
            <br>
              <br>
                To learn more about the standards that we observe while your personal data are in our custody,
                you may visit our Privacy Statement at
                <a style="color: #5F96BA; text-decoration: underline;word-break: break-word;"
                  rel="noopener"
                  href="https://company.meralco.com.ph/privacy-statement"
                  target="_blank">https://company.meralco.com.ph/privacy-statement
                </a>.
                <br>
                  <br>
                    If you have concerns on how your personal data were handled or wish to exercise your rights under the Data Privacy Act of 2012, you may send an email to
                    <a style="color: #5F96BA;text-decoration: underline;"
                      rel="noopener"
                    href="mailto:cdpo@meralco.com.ph" target="_blank">cdpo&#64;meralco.com.ph</a>.
                    <br>
                      <br>
                        <br>
                          <p class="terms_title">Certified by MERALCO Contractors Program</p>
                          <p class="terms_title">Terms and Conditions</p>
                          <br>
                            By clicking the checkbox, I am availing of the Private Electrical Contractors Certified by Meralco (“PECCBM”) Program,
                            in connection with my application of electric service or other related services with Manila Electric Company (“MERALCO”),
                            and agree to the following terms and conditions:
                            <br>
                              <ol>
                                <li>
                                  I shall be dealing directly with the PECCBM Contractor of my choice including the payment of its services.
                                </li>
                                <li>
                                  I fully understand that the PECCBM Contractor shall be solely responsible for any claim, action or
                                  liability which may result from the performance of its services and those of its personnel and contractors,
                                  if any. I hereby acknowledge that the PECCBM Contractor personnel are not employees or agents of MERALCO.
                                </li>
                                <li>
                                  I understand that MERALCO is not involved and does not participate in my engagement of the services of the
                                  PECCBM Contractor. For this purpose, I hereby waive in favor of MERALCO, its directors, employees or agents,
                                  any and all rights of action, claims or demands for any loss or damage that I may suffer or incur arising from
                                  or in connection with the performance of services by the PECCBM Contractor and with my participation in or my
                                  availing of the PECCBM Program.
                                </li>
                                <li>
                                  I voluntarily provide my personal and sensitive personal information to MERALCO (“Personal Data”)
                                  solely to enable MERALCO to process and notify me about the service request I lodged in the PECCBM
                                  Online Platform. I understand that I may seek assistance from its Data Privacy Office to exercise
                                  my rights as a data subject over the Personal Data that I provided.
                                </li>
                                <li>
                                  I hereby allow MERALCO to share my Personal Data with the PECCBM Contractor of my choosing,
                                  in order for the PECCBM Contractor to successfully perform intended services, which includes
                                  but is not limited to the required services in connection with my application of electric service
                                  or other related services
                                </li>
                                <li>
                                  I understand that MERALCO’s processing of my Personal Data is limited only to the purposes
                                  stated above. I further understand that the PECCBM Contractor’s processing of my shared
                                  Personal Data to successfully perform intended services is independent of MERALCO’s.
                                  As such, the PECCBM Contractor’s use of my Personal Data for their own legitimate purpose/s
                                  is outside the scope of MERALCO’s personal data processing
                                </li>
                                <li>
                                  I hereby allow, further, the PECCBM Contractor to share with MERALCO any information gathered
                                  in the performance of the services for the completion of my application of electric service or
                                  other related services for which the PECCBM Contractor has been engaged
                                </li>
                                <li>
                                  I certify and warrant that the Data so disclosed to MERALCO are true, accurate and correct.
                                  Should any information in the Data become incorrect, I shall endeavor to undertake best efforts
                                  to inform MERALCO of any change in the Data, which shall be then shared with the PECCBM Contractor
                                  so engaged
                                </li>
                                <li>
                                  I shall defend, protect, indemnify and hold MERALCO, its directors, officers, employees and agents,
                                  free and harmless from and against any and all claims, actions, losses, damages and expenses
                                  (including reasonable attorney's fees) arising out of any inaccuracy or error in the Data known to
                                  me or ought to have been known to me, and which I failed to bring to MERALCO’s attention.
                                </li>
                                <li>
                                  MERALCO may, from time to time, amend or modify this PECCBM Program Terms and Conditions without
                                  prior notice and MERALCO may, at any time, modify, suspend or permanently stop and/or remove any
                                  aspect or feature of the PECCBM Program.
                                </li>
                                <li>
                                  If any of the terms and conditions herein stated is found to be unenforceable or invalid under
                                  any applicable law or rules, such unenforceability or invalidity shall not render the other
                                  terms or conditions as unenforceable or invalid as a whole, and such unenforceable or invalid
                                  provisions shall be deleted without affecting the remaining provisions.
                                </li>
                                <li>
                                  If I violate any of the terms and conditions herein, MERALCO may use the same as ground to deny my
                                  future availing of participation in the PECCBM Program, without prejudice to its right to avail of
                                  any appropriate remedies under the law.
                                </li>
                                <li>
                                  I may give feedback and comments regarding my participation in the PECCBM Program, including the
                                  performance of PECCBM Contractor I have engaged with, as part of MERALCO’s objective to improve
                                  its services to customers.
                                </li>
                              </ol>
                            </div>
                            <div class="d-flex flex-column align-items-center"
                              style="width: 100%;">
                              <div class="checkbox-container">
                                <div>
                                  <span class="customer-checkbox"
                                    [ngClass]="{'customer-checkbox-selected': acceptPolicy }"
                                    (click)="chk1.click()">
                                    <input type="checkbox"
                                      class="customer-checkbox"
                                      #chk1
                                      [(ngModel)]="acceptPolicy"/>
                                    </span>
                                  </div>
                                  <div class="checkbox-text">
                                    <span (click)='acceptPolicy = !acceptPolicy' style="cursor: pointer">I have read and agree with the</span>
                                    <span style="display: inline-block;"><a href="https://company.meralco.com.ph/privacy-policy" class="policy-link" target="_blank" rel="noopener">Privacy Policy</a></span>
                                  </div>
                                </div>
                              </div>
                              <div class="checkbox-container">
                                <div>
                                  <span class="customer-checkbox"
                                    [ngClass]="{'customer-checkbox-selected': acceptTerms }"
                                    (click)="chk2.click()">
                                    <input type="checkbox"
                                      class="customer-checkbox"
                                      #chk2
                                      [(ngModel)]="acceptTerms"/>
                                    </span>
                                  </div>
                                  <div class="checkbox-text">
                                    <span (click)='acceptTerms = !acceptTerms' style="cursor: pointer">I have read and agree with the</span>
                                    <span style="display: inline-block;"><a href="/terms" class="policy-link" target="_blank">Terms & Conditions</a></span>
                                  </div>
                                </div>
                                <button class="button button-active"
                                  (click)="accept()"
                                [disabled]="!(acceptPolicy && acceptTerms)">Continue</button>
                              </div>
                            </div>
                          }
